
import ApiGenericServicesData from 'service/ApiGenericServicesData';
import { codificarValorSeguro } from "util/codificarValorSeguro";

export default class CertificacionDeAfiliacionAPartidoPolitico extends ApiGenericServicesData{
    constructor(){
        super("certificacionDeAfiliacionAPartidoPolitico");
    }

    async openFile(fileName) {         
        const fileNameSeguro = await codificarValorSeguro(fileName);
        return this.customGET("openFile/" + fileNameSeguro);    
    }
}
